import React from 'react'

interface CircleIconProps {
  strokeColor?: string,
  automatedTestId?: string,
  id?: string,
  className?:string,
  onclick?: any,
  color?:string
}

//Deselected radio
export const ZoomIcon: React.FC<CircleIconProps> = (props) => (
    <svg className={props.className} id={props.id} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 25 25">
        <circle fill={props.color} id={props.id ?? "checkbox-deselected-green"} cx="12.5" cy="12.5" r="12.5"/>
    </svg>
);

//Selected radio
export const DarkGreyIcon: React.FC<CircleIconProps> = (props) => (
    <svg  xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <circle id={props.id ?? "checkbox-selected-grey"} fill="#E9E9E9"  cx="12.5" cy="12.5" r="12.5"/>
    </svg>
);

export const CheckedIcon: React.FC<CircleIconProps> = (props) => (
    <svg  xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <circle id={props.id ?? "checkbox-selected-"+props.color} fill={props.color}  cx="12.5" cy="12.5" r="12.5"/>
    </svg>
);